import { Inject, Options, Vue } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import ViewTerminatePracticeModal from "./view-terminate-practice-modal/index.vue";
import AddAppointedPracticeModal from "./add-appointed-practice-modal/index.vue";
import { IndividualPracticeSummaryForExternalExaminer } from "@/shared/modules/typescript-trustapi-client/models";

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    ViewTerminatePracticeModal,
    AddAppointedPracticeModal,
  },
  mixins: [FormatDateTimeMixin]
})
export default class ExternalExaminerDashboard extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private firstLoad = true;
  private loadingContent = false;
  private errorLoadingContent = false;
  private showAddEEModal = false;

  private practiceList: any = [];
  private showViewTerminatePracticeModal = false;
  private showAddAppointedPracticeModal = false;
  private selectedPractice: any = {};

  private tableHeadings = [
    { text: 'Practice Name', value: 'name', sortable: false },
    { text: 'Law Practice ID', value: 'lawPracticeID', sortable: false },
    { text: 'Branch Address', value: 'address', sortable: false },
    { text: 'Appointed Date', value: 'startDate', sortable: false },
    { text: 'Terminated Date', value: 'endDate', sortable: false },
    { text: 'Action', value: 'action', sortable: false },
  ];

  mounted(): void {
    this.getPractice();
  }

  private getPractice(): void {
    this.firstLoad = false;
    this.loadingContent = true;
    this.errorLoadingContent = false;
    const ExternalExaminerId: number = parseInt(this.$route.query.eeId as string, 10);
    if (ExternalExaminerId) {
      this.apiService.PracticeAtcsApi?.apiV2AtcsPracticeAdminGetIndividualPracticesForExternalExaminerExternalExaminerIdGet(ExternalExaminerId)
        .then((resp: any) => {
          this.practiceList = this.sortPracticeList(resp.data.data);
          this.loadingContent = false;
        }).catch((err: any) => {
          this.loadingContent = false;
          this.errorLoadingContent = true;
          this.ai.trackException(err);
        });
    }

  }

  private sortPracticeList(list: IndividualPracticeSummaryForExternalExaminer[]): IndividualPracticeSummaryForExternalExaminer[] {
    // set to two groups, with and without effectiveEndDate
    // then sort by effectiveStartDate in descending order
    const withEndDate = list.filter((p: any) => p.effectiveEndDate !== null);
    const withoutEndDate = list.filter((p: any) => p.effectiveEndDate === null);
    withEndDate.sort((a: any, b: any) => {
      return new Date(b.effectiveStartDate).getTime() - new Date(a.effectiveStartDate).getTime();
    });
    withoutEndDate.sort((a: any, b: any) => {
      return new Date(b.effectiveStartDate).getTime() - new Date(a.effectiveStartDate).getTime();
    });
    return [...withoutEndDate, ...withEndDate];
  }

  private openView(p: any) {
    this.selectedPractice = p;
    this.showViewTerminatePracticeModal = true;
  }
}

